"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _permission = require("@/utils/permission");
var _Record = _interopRequireDefault(require("./Record.vue"));
var _Delivery = _interopRequireDefault(require("./Delivery.vue"));
var _WarningDetail = _interopRequireDefault(require("./WarningDetail.vue"));
var _DivisionRecordPanel = _interopRequireDefault(require("./DivisionRecordPanel.vue"));
var _PaymentMonitor = _interopRequireDefault(require("./PaymentMonitor.vue"));
var _SupplierOrderRecordPanel = _interopRequireDefault(require("./SupplierOrderRecordPanel.vue"));
var _OrderItemRefundStatus = _interopRequireDefault(require("@/components/OrderItemRefundStatus.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderDetail',
  props: {
    orderNo: {
      type: String,
      default: ''
    },
    isShowWarning: {
      type: Boolean,
      default: false
    },
    activeNameTab: {
      type: String,
      default: 'detail'
    }
  },
  components: {
    OrderRecord: _Record.default,
    Delivery: _Delivery.default,
    WarningDetail: _WarningDetail.default,
    DivisionRecordPanel: _DivisionRecordPanel.default,
    PaymentMonitor: _PaymentMonitor.default,
    SupplierOrderRecordPanel: _SupplierOrderRecordPanel.default,
    OrderItemRefundStatus: _OrderItemRefundStatus.default
  },
  data: function data() {
    return {
      checkPermi: _permission.checkPermi,
      activeName: this.activeNameTab,
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      InvoiceList: [],
      orderExtend: [],
      detailRequestId: 0,
      refreshTimer: null,
      refreshing: false,
      monitorRefreshFailed: false
    };
  },
  watch: {
    dialogVisible: function dialogVisible(open) {
      if (open) this.startRefresh();else this.stopRefresh();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopRefresh();
  },
  filters: {
    moneyUnit: function moneyUnit(val) {
      var result = '0.00';
      if (Number(val)) result = val + '元';
      return result;
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.stopRefresh();
      this.activeName = this.activeNameTab;
      this.dialogVisible = false;
    },
    startRefresh: function startRefresh() {
      var _this = this;
      if (this.refreshTimer) return;
      // ponytail: one bounded poll while the drawer is open; backend timestamps remain the freshness source.
      this.refreshTimer = setInterval(function () {
        if (!_this.loading && !_this.refreshing && _this.orderNo) _this.getDetail(_this.orderNo, true);
      }, 60000);
    },
    stopRefresh: function stopRefresh() {
      if (this.refreshTimer) clearInterval(this.refreshTimer);
      this.refreshTimer = null;
      this.refreshing = false;
      this.detailRequestId++;
    },
    getOrderInvoiceList: function getOrderInvoiceList(id) {
      var _this2 = this;
      (0, _order.orderInvoiceListApi)(id).then(function (res) {
        _this2.InvoiceList = res;
      }).catch(function () {});
    },
    getDetail: function getDetail(id) {
      var _this3 = this;
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var requestId = ++this.detailRequestId;
      if (silent) this.refreshing = true;else {
        this.orderDatalist = {};
        this.orderExtend = [];
        this.refreshing = false;
        this.monitorRefreshFailed = false;
        this.loading = true;
      }
      return (0, _order.orderDetailApi)({
        orderNo: id
      }).then(function (res) {
        if (requestId !== _this3.detailRequestId) return;
        _this3.orderDatalist = res || {};
        _this3.monitorRefreshFailed = false;
        _this3.orderExtend = [];
        if (res && res.orderExtend) {
          try {
            var parsed = JSON.parse(res.orderExtend);
            _this3.orderExtend = Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            // ponytail: legacy dirty orderExtend must not break the whole detail drawer
          }
        }
        _this3.refreshing = false;
        if (!silent) _this3.activeName = _this3.activeNameTab;
        if (!silent) _this3.loading = false;
        if (!silent && _this3.isShowWarning) {
          _this3.$nextTick(function () {
            _this3.$refs.warningDetailRef.getDetail();
          });
        }
      }).catch(function () {
        if (requestId !== _this3.detailRequestId) return;
        _this3.refreshing = false;
        _this3.monitorRefreshFailed = true;
        if (!silent) {
          _this3.orderDatalist = {};
          _this3.loading = false;
        }
      });
    },
    onTabChange: function onTabChange(tab) {
      switch (tab.name) {
        case 'warning':
          this.$refs.warningDetailRef.getDetail();
          break;
        case 'delivery':
          this.$refs.deliveryRef.getList();
          break;
        case 'record':
          this.$refs.orderRecordRef.getList();
          break;
        case 'supplierOrder':
          this.$refs.supplierOrderRecordRef.getList();
          break;
        default:
          break;
      }
    }
  }
};